module.exports = __webpack_public_path__ + "media/images/malvinas/iso_ok.orig-d2f2f40d219cb6011e5918b05c7aeaf8.svg";